"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var ShippingAlt = function ShippingAlt(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#666666' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'original' : _ref$size,
      _ref$langContext = _ref.langContext,
      langContext = _ref$langContext === void 0 ? {
    translate: function translate(text) {
      return text;
    }
  } : _ref$langContext;
  var iconSize = size === 'original' ? 'width="24" height="24"' : 'width="100%"';
  var title = langContext.translate('Shipping Alt Icon');
  return "\n    <svg aria-label={title} ".concat(iconSize, " fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <title>").concat(title, "</title>\n      <g id=\"/fulfillment/ship-to-you\">\n        <path id=\"color\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.01123 7.00424V16.0148L11.9898 21.994V13.0103L2.01123 7.00424ZM13.0118 12.4001V21.3944L22.0001 16.0148V7.00984L13.0118 12.4001ZM12.0012 21.9992H11.9986L11.9999 22L12.0012 21.9992ZM11.9999 12L7.82424 9.50379L16.5477 4.27231L21.1196 6.55954L11.9999 12ZM2.89573 6.5575L7.0277 9.02761L15.6801 3.83825L12.0056 2L2.89573 6.5575Z\" fill=\"").concat(color, "\"/>\n      </g>\n    </svg>\n  ");
};

var _default = ShippingAlt;
exports["default"] = _default;